import React from 'react';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import {green400 } from 'material-ui/styles/colors';
import {lfGreen, lfTan} from './lfColors.js';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
const addButtonStyle = {
    marginRight: 20,
    marginLeft:20,
  };
  

  const muiTheme = getMuiTheme({
    palette: {
      primary1Color: lfGreen[300],
      accent1Color: lfGreen[400],
      pickerHeaderColor: green400,
      color:lfTan[100],
    },
    menuItem: {
      selectedTextColor: green400,
    },
  });

class AddFloatingButton extends FloatingActionButton {
    handleOnClick = () => {
        this.props.onRequestShowAddDialog( null )
      }
      render() {
        return(

          <MuiThemeProvider muiTheme={muiTheme}>
            <FloatingActionButton  
               backgroundColor="#4F9850"
              
              onClick={this.handleOnClick}           
              style={addButtonStyle}
            >
              <ContentAdd />
            </FloatingActionButton>
          </MuiThemeProvider>

        )
      }




}


export default AddFloatingButton


// WEBPACK FOOTER //
// ./src/Components/AddFloatingButton.js